export default "__VITE_ASSET__C_rSOA4i__"